import React, { Component } from "react";
//import LoadingCube from 'sub_components/Common/LoadingCube';
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
import { Permissions } from "services/permissions";
import { PortalWrapper } from "sub_components/Layout/PortalWrapper";
import { getCompanyInfo } from "actions/company";
import InfoModal from "sub_components/Common/InfoModal";

class ProtectedRoute extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasProfileAccess: false,
      hasBillingAccess: false,
      hasStorageAccess: false,
      hasSupportAccess: false,
      hasColoAccess: null,
      showInfo: false,
    };
  }
  isUserAuthenticated(isAuthenticated, user) {
    let status = false;
    if (isAuthenticated && user) {
      status = true;
    }
    return status;
  }

  componentDidMount() {
    const {
      getCompanyInfo,
      auth_status: { memberships },
      company_info: { customer: { id } = {} } = {},
    } = this.props;
    const organizationId = memberships?.[0]?.organizationId;
    if (organizationId) {
      getCompanyInfo(organizationId);
    }
    if (id) {
      this.setAccess(id);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      getCompanyInfo,
      auth_status: { memberships },
      company_info: { customer: { id } = {} } = {},
    } = this.props;
    const organizationId = memberships?.[0]?.organizationId;
    const previousCompanyId =
      prevProps?.auth_status?.memberships?.[0]?.organizationId;

    if (organizationId !== previousCompanyId) {
      getCompanyInfo(organizationId);
    }
    if (prevProps?.company_info?.customer?.id !== id) {
      this.setAccess(id);
    }
  }
  setAccess = (id) => {
    const { auth_status } = this.props;
    const { memberships } = auth_status;

    const { access: hasBillingAccess } = Permissions.hasService(
      memberships,
      "Billing",
      id
    );
    const { access: hasStorageAccess } = Permissions.hasService(
      memberships,
      "Storage",
      id
    );
    const { access: hasProfileAccess } = Permissions.hasService(
      memberships,
      "Account",
      id
    );
    const { access: hasSupportAccess } = Permissions.hasService(
      memberships,
      "Support",
      id
    );
    const { access: hasColoAccess } = Permissions.hasService(
      memberships,
      "Colocation",
      id
    );

    this.setState({
      hasBillingAccess,
      hasProfileAccess,
      hasStorageAccess,
      hasSupportAccess,
      hasColoAccess,
    });
  };

  setShowModal = () => {
    return setTimeout(() => {
      this.setState({ showInfo: true });
    }, 3000);
  };

  render() {
    const {
      hasBillingAccess,
      hasProfileAccess,
      hasStorageAccess,
      hasSupportAccess,
      hasColoAccess,
      showInfo,
    } = this.state;
    const { auth_status } = this.props;
    const { isAuthenticated, user, isFetching } = auth_status;
    const body = document.querySelector("body");
    this.isUserAuthenticated(isAuthenticated, user) &&
    !hasProfileAccess &&
    !isFetching
      ? this.setShowModal()
      : false;

    if (this.isUserAuthenticated(isAuthenticated, user) && hasProfileAccess) {
      return (
        <PortalWrapper
          isAuthenticated={isAuthenticated}
          hasBillingAccess={hasBillingAccess}
          hasProfileAccess={hasProfileAccess}
          hasStorageAccess={hasStorageAccess}
          hasSupportAccess={hasSupportAccess}
          hasColoAccess={hasColoAccess}
        />
      );
    } else if (
      !this.isUserAuthenticated(isAuthenticated, user) &&
      !isFetching
    ) {
      return <Navigate to="/login" />;
    } else if (
      this.isUserAuthenticated(isAuthenticated, user) &&
      !hasProfileAccess &&
      !isFetching
    ) {
      if (showInfo && !body.classList.contains("loading")) {
        return (
          <InfoModal
            success={false}
            open={true}
            error="There is an error with your account. Please contact our support team."
          />
        );
      }
    } else {
      return <div className="loading-portal">{/* <LoadingCube /> */}</div>;
    }
  }
}

function mapStateToProps(state) {
  return {
    auth_status: state.auth_status,
    company_info: state.company_info,
  };
}

export default connect(mapStateToProps, { getCompanyInfo })(ProtectedRoute);
